<template>
	<Html lang="sv"></Html>
	<LazyLoadWrapper>
		<NuxtLoadingIndicator />
		<SharedModal />
	</LazyLoadWrapper>
	<main v-if="renderComponent">
		<Header />
		<slot />
		<LazyLoadWrapper>
			<Footer />
			<SpeedInsights />
		</LazyLoadWrapper>
	</main>
</template>

<script setup lang="ts">
import { nextTick, ref, provide } from "vue";
import { SpeedInsights } from "@vercel/speed-insights/nuxt";
import LazyLoadWrapper from "~/components/LazyLoadWrapper.vue";

const renderComponent = ref(true);

const forceRender: () => Promise<void> = async () => {
	renderComponent.value = false;
	await nextTick();
	renderComponent.value = true;
};

provide("forceRender", forceRender);

const nuxtApp = useNuxtApp();

const loading = ref(true);

nuxtApp.hook("app:suspense:resolve", () => {
	loading.value = false;
});

const { initLayoutData } = useLayoutInit();
await initLayoutData();
</script>
